import { UserPermission } from '@/modules/permission/enum';
export const sourceRoutes = [
    {
        path: '',
        name: 'Source',
        exact: true,
        component: () => import('../views/SourceIndex.vue'),
        meta: {
            breadcrumb: [{ parent: 'Source', label: 'Manage Sources' }],
            permissions: [UserPermission.WRITE_SOURCE],
        },
    },
];
